import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';

import { ContentSurveyItem } from '@app/gen/community';

import { ContentSurveysPassingSubmitData } from '../../types';

import { ContentSurveysItemPassing } from './ContentSurveysItemPassing';

interface ContentSurveysPassingProps {
  surveys: ContentSurveyItem[];
  onSubmit?: (data: ContentSurveysPassingSubmitData) => Promise<unknown>;
  preview?: boolean;
}

export const ContentSurveysPassing = ({
  surveys,
  onSubmit,
  preview,
}: ContentSurveysPassingProps) => {
  return (
    <Box display="flex" flexDirection="column" gap="20">
      {surveys.map((surveyItem) => (
        <ContentSurveysItemPassing
          key={surveyItem.survey.id}
          survey={surveyItem}
          onSubmit={onSubmit}
          preview={preview}
        />
      ))}
    </Box>
  );
};
